// extracted by css-extract-rspack-plugin
export default {"cls1":"SplitVerdictPreviewList-cls1_6H5","cls2":"SplitVerdictPreviewList-cls2_qSt SplitVerdictPreviewList-cls1_6H5"};